import React, { useState, useEffect } from "react";
import GetEventDetail from "./GetEvent.jsx/GetEventDetail"
import EventDenied from "./GetEvent.jsx/EventDenied"
import { FormProvider } from './FormContext'
import { Navigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { EVENT_VISIBLE_TO_USER } from './ApiDetails.js';

function GetDetail() {
  const location = useLocation();
  const urlSplit = location.pathname.split('/');
  const eventId = urlSplit.pop();
  const subSection = urlSplit.pop();
  const fromAdmin = localStorage.getItem('fromAdminMode') === 'true';
  const role = localStorage.getItem('role');

  const [eventIsVisible, setEventIsVisible] = useState(false);
  const [eventStatus, setEventStatus] = useState("");
  const [userIsEventRequestor, setUserIsEventRequestor] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [secuOK, setSecuOK] = useState(false);
  
  const getIsEventVisible = async (eventID) => {
        await axios.get(`${EVENT_VISIBLE_TO_USER}/${eventID}`)
          .then(response => {
              var data = response.data;
              if (data != null) {
                  setEventStatus(data.status);
                  setEventIsVisible(data.visible);
                  setUserIsEventRequestor(data.userIsEventRequestor);
                  setSecuOK(true);
              }
          })
          .catch(error => {
              console.error('Error reading event : ', error);
          });
  }

  useEffect(() => {
      if (isFirstLoad) {
          getIsEventVisible(eventId);
          setIsFirstLoad(false);
      }
 }, []);

  //const renderPage = () => {
  if (!secuOK) {
      return "";
  } else
  if (!eventIsVisible) {
    if (eventStatus==="deleted")
      return (<div><Navigate to="/" replace /></div>)
    else
      return (<FormProvider><EventDenied /></FormProvider>)
  }
  else
  switch (role) {
    case 'Visit Requester':
    case 'Requester':
      return (
        <FormProvider>
          <GetEventDetail />
        </FormProvider>
      )
    case 'MLTUser':
    case 'MLTCoordinator':
      return (
        <div>
          <Navigate to={`/GetDetailEventMlt${subSection.toLowerCase()!='getdetail' ? "/"+subSection : ""}/${eventId}`} replace />
        </div>
      )
    case 'Admin':
      if (fromAdmin)
        return (
          <FormProvider>
            <GetEventDetail />
          </FormProvider>
        )
      else
        return (
          <div>
            <Navigate to={`/GetDetailAdmin${subSection.toLowerCase()!='getdetail' ? "/"+subSection : ""}/${eventId}`} replace />
          </div>
        )
    case 'Family':
    case 'FamilyCoordinator':
      if (((eventStatus==="Draft") || (eventStatus==="Under review")) && eventIsVisible)
      return (
        <FormProvider>
          <GetEventDetail />
        </FormProvider>
      )
      else
      return (
        <div>
          <Navigate to={`/getDetailMarsComplete${subSection.toLowerCase()!='getdetail' ? "/"+subSection : ""}/${eventId}`} replace />
        </div>
      )
    default:
      return (
        <div>
          <Navigate to="/" replace />
        </div>
      )
  }
}
//} renderPage();

export default GetDetail;